import React from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import ApplicationLayout from 'layouts/application'
import CalculatorContent from 'components/calculator'
import { ArticleJsonLd } from 'components/shared/schema/article'
import { pageUri } from 'shared/util'
import { initializeApollo, addApolloState } from 'util/apolloClient'
import { Calculator_With_NavDocument } from 'graphql/generated/types'

const title = (name) => {
  return `${name} Calculator, Formula, Meaning Online`
}
const description = (name) =>
  `Get ${name} Calculator, Formula online. How to calculate current ratio of any company`
export default function Calculator(props) {
  const router = useRouter()
  const { asPath } = router
  const { data } = props
  const {
    all_brokers: allBrokers,
    slugCalculator,
    nav_calculators: navCalculators,
    all_pages: { data: allPages },
  } = data
  const calculatorData = slugCalculator.data[0]
  const { name, image } = calculatorData.attributes
  const pageTitle = title(name)
  const pageDescription = description(name)
  let images = []
  const Image = image?.file ? image : null
  if (Image?.file?.formats?.large) {
    images = [Image?.file?.formats.large.url]
  } else {
    images = [Image?.file?.url]
  }
  return (
    <ApplicationLayout
      allBrokers={allBrokers.data}
      navCalculators={navCalculators.data}
      allPages={allPages}
    >
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Head>
      <ArticleJsonLd
        url={pageUri(asPath)}
        images={images}
        title={pageTitle}
        description={pageDescription}
      />
      <CalculatorContent calculatorData={calculatorData} />
    </ApplicationLayout>
  )
}
export async function getServerSideProps(context) {
  const apolloClient = initializeApollo()
  const {
    query: { slug },
  } = context
  const queryResults = await apolloClient.query({
    query: Calculator_With_NavDocument,
    variables: { slug },
  })
  const { data } = queryResults
  return addApolloState(apolloClient, {
    props: { data },
  })
}
